// src/data/DataContext.js

import {createContext} from 'react'
const DataContext = createContext()

//Consumer: {$$typeof: Symbol(react.context), _context: {…}, _calculateChangedBits: null, …}
//Provider: {$$typeof: Symbol(react.provider), _context: {…}}

export { DataContext }
